import { API_ENDPOINT, useClientApiV1SessionsQuery } from '../../resources/@types/accountSchema';

function useClientSessionQuery(
  options?: Parameters<typeof useClientApiV1SessionsQuery>[0]['options'],
) {
  return useClientApiV1SessionsQuery({
    queryKey: [API_ENDPOINT.CLIENT_V1_SESSIONS],
    url: API_ENDPOINT.CLIENT_V1_SESSIONS,
    options,
  });
}

useClientSessionQuery.queryKey = [API_ENDPOINT.CLIENT_V1_SESSIONS];

export default useClientSessionQuery;
